module.exports = __webpack_public_path__ + "img/arrow-left.06a00a96.svg";